import type { GuestSession } from '../../auth';

/**
 * The guest session is a snapshot taken once, at sign-in. Merging a freshly
 * read row back into it is one small, pure step, kept separate from the
 * effect that fetches the row so it can be tested without a network or a
 * browser.
 *
 * Guarded against a stay change that landed while the fetch was in flight
 * (a sign-out and a different sign-in, in the same tab): if the id the fresh
 * row belongs to no longer matches the session's, the session is returned
 * unchanged rather than mixing one stay's dates into another's session.
 */
export function mergeStayRefresh(
  session: GuestSession,
  freshStayId: string,
  fresh: Pick<GuestSession['stay'], 'tier' | 'arrives_on' | 'departs_on' | 'status'>,
): GuestSession {
  if (session.stay.id !== freshStayId) return session;
  return { ...session, stay: { ...session.stay, ...fresh } };
}
